import { confirmPasswordReset as confirmPasswordResetFirebase } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@core/services/api/firebase";

export async function confirmPasswordReset(
  oobCode: string,
  newPassword: string,
  onError?: () => void
) {
  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    const result = await confirmPasswordResetFirebase(
      auth,
      oobCode,
      newPassword
    );

    return result;
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}

export default confirmPasswordReset;

